import { SearchResult } from "@/shared/apis/searchApi";

export const getSearchItemId = (item: SearchResult) => {
    return `search-result-${item.type}-${item.id}`;
};
